import AssignmentRounded from "@mui/icons-material/AssignmentRounded";
import CalendarTodayRounded from "@mui/icons-material/CalendarTodayRounded";
import ErrorOutlineRounded from "@mui/icons-material/ErrorOutlineRounded";
import VerifiedUserRounded from "@mui/icons-material/VerifiedUserRounded";
import WarningAmberRounded from "@mui/icons-material/WarningAmberRounded";

const ICONS = {
  clipboard: AssignmentRounded,
  check: VerifiedUserRounded,
  alert: WarningAmberRounded,
  alertOctagon: ErrorOutlineRounded,
  calendar: CalendarTodayRounded
};

export default function SummaryCards({ items }) {
  return (
    <section data-tour="summary-cards" className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      {items.map((card) => {
        const Icon = ICONS[card.icon] || AssignmentRounded;
        return (
          <article
            key={card.key}
            className="group rounded-2xl border border-slate-200/90 bg-white p-4 shadow-[0_1px_3px_rgba(15,23,42,0.05)] transition-all duration-300 hover:-translate-y-0.5 hover:border-slate-300/90 hover:shadow-[0_8px_24px_rgba(15,23,42,0.08)]"
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-xs font-medium text-slate-500">{card.label}</p>
                <p className="mt-2 text-2xl font-semibold tabular-nums tracking-tight text-slate-900">{card.value}</p>
                <p className="mt-1 text-xs text-slate-500">{card.note}</p>
              </div>
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-50 text-slate-600 ring-1 ring-slate-200/80 transition-colors duration-300 group-hover:bg-blue-50 group-hover:text-blue-600 group-hover:ring-blue-200/60">
                <Icon sx={{ fontSize: 22 }} />
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
}
